import React from 'react';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import getPersonalisedProduct from 'store/product/selector/getPersonalisedProduct';
import styles from './BackToSeeAllButton.module.scss';

interface Props {
  primary?: boolean;
  secondary?: boolean;
}

const BackToSeeAllButton = ({ primary, secondary }: Props) => {
  const personalisedProduct = useSelector(getPersonalisedProduct);
  if (!personalisedProduct) return null;

  const { seeAllButtonReferenceUrl, seeAllButtonLabel } = personalisedProduct as any;
  if (!seeAllButtonReferenceUrl) return null;

  return (
    <a
      href={seeAllButtonReferenceUrl}
      className={cn(styles.seeAll, {
        [styles.primary]: primary,
        [styles.secondary]: secondary,
      })}
    >
      {seeAllButtonLabel}
    </a>
  );
};

export default BackToSeeAllButton;
